<template>
    <v-stepper v-model="step" class="pt-10 elevation-0">
        <v-stepper-items>
            <v-stepper-content step="1">
                <v-card
                    v-for="period in periods"
                    :key="period.id"
                    @click="tryoutRegistration(false, period)"
                    outlined
                    link
                    class="mb-2"
                >
                    <v-card-title>{{ period.title }}</v-card-title>
                    <v-card-subtitle>
                        <template v-if="period.is_trial">
                            Trial
                        </template>

                        <template v-else>
                            Rp {{ period.price }}
                        </template>
                    </v-card-subtitle>
                    <v-card-text>{{ period.description }}</v-card-text>
                </v-card>
<!--
                <v-card @click="tutoringRegistration" class="mt-6" outlined link>
                    <v-card-title>Bimbingan Belajar</v-card-title>
                    <v-card-subtitle>Rp 135.000 / orang</v-card-subtitle>
                    <v-card-text>Daftar bimbingan belajar dan dapatkan tryout online gratis.</v-card-text>
                </v-card> -->
            </v-stepper-content>

            <v-stepper-content step="2">
                <signup-back-button @click="home"></signup-back-button>

                <signup-group-name @next="tryoutRegistration(true)"></signup-group-name>
            </v-stepper-content>

            <v-stepper-content step="3">
                <signup-back-button @click="backFromTryout"></signup-back-button>

                <signup-tryout-data></signup-tryout-data>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import { sync } from 'vuex-pathify'
import priceFormat from '@/tools/priceFormat'
import SignupBackButton from './SignupBackButton'
import SignupGroupName from './SignupGroupName'
import SignupTryoutData from './SignupTryoutData'

const STEP_HOME = 1
const STEP_TUTORING_NAMEFORM = 2
const STEP_TRYOUT_FORM = 3
// const STEP_TUTORING_FORM = 3

export default {
    components: {
        SignupBackButton,
        SignupGroupName,
        SignupTryoutData,
    },

    data() {
        return {
            periods: [],
        }
    },

    computed: {
        step: sync('home/signupStep'),
        tryoutBackTo: sync('home/signupTryoutBackTo')
    },

    methods: {
        backFromTryout() {
            this.step = this.tryoutBackTo
        },

        tryoutRegistration(fromtutoring = false, period = null) {
            this.step = STEP_TRYOUT_FORM

            if (fromtutoring) {
                this.tryoutBackTo = STEP_TUTORING_NAMEFORM
            } else {
                this.$store.set('home/groupName', null)
                this.$store.set('home/period', period)
                this.tryoutBackTo = STEP_HOME
                this.$tracking.event.program.click(period.title)
            }
        },

        tutoringRegistration() {
            this.step = STEP_TUTORING_NAMEFORM
        },

        home() {
            this.step = STEP_HOME
        },
    },

    created() {
        this.$api.get('tryoutPeriod')
            .then(response => {
                this.periods = response.data.tryoutPeriods.map(period => {
                    period.price = priceFormat(period.price)
                    period.description = period.description ? period.description.split('\n')[0] : ''

                    return period
                })
            })
    }
}
</script>
